import { render, staticRenderFns } from "./TotalRecordsBadge.vue?vue&type=template&id=01b5ca9f&scoped=true&"
import script from "./TotalRecordsBadge.vue?vue&type=script&lang=js&"
export * from "./TotalRecordsBadge.vue?vue&type=script&lang=js&"
import style0 from "./TotalRecordsBadge.vue?vue&type=style&index=0&id=01b5ca9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5ca9f",
  null
  
)

export default component.exports